import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BemaPaymentsSyncService from '../../../service/settings/BemaPaymentsSync';

const getErrorMessage = (error) =>
  (error.response && error.response.data && error.response.data.message) ||
  error.message ||
  error.toString();

// ===============================
// 🔹 Get Pending Bima Payments
// ===============================
export const getPendingBimaPayments = createAsyncThunk(
  'BemaPaymentsSyncSlice/getPendingBimaPayments',
  async (_, thunkAPI) => {
    try {
      const response = await BemaPaymentsSyncService.getPendingBimaPayments();

      return {
        status: response.data?.status,
        message: response.data?.message || '',
        PendingBimaPayments: Array.isArray(response.data?.data) ? response.data.data : [],
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  },
);

// ===============================
// 🔹 Manual Bima Sync
// ===============================
export const manualBimaSync = createAsyncThunk(
  'BemaPaymentsSyncSlice/manualBimaSync',
  async (data, thunkAPI) => {
    try {
      const response = await BemaPaymentsSyncService.manualBimaSync(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  },
);

// ===============================
// 🔹 Slice
// ===============================
const BemaPaymentsSyncSlice = createSlice({
  name: 'BemaPaymentsSyncSlice',
  initialState: {
    PendingBimaPayments: [],
    message: '',
    loading: false,
    syncLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPendingBimaPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPendingBimaPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.PendingBimaPayments = action.payload.PendingBimaPayments;
        state.message = action.payload.message;
      })
      .addCase(getPendingBimaPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.PendingBimaPayments = [];
        state.message = '';
      })

      .addCase(manualBimaSync.pending, (state) => {
        state.syncLoading = true;
        state.error = null;
      })
      .addCase(manualBimaSync.fulfilled, (state) => {
        state.syncLoading = false;
      })
      .addCase(manualBimaSync.rejected, (state, action) => {
        state.syncLoading = false;
        state.error = action.payload;
      });
  },
});

export default BemaPaymentsSyncSlice.reducer;
